import { render, staticRenderFns } from "./Pools.vue?vue&type=template&id=3d185492&"
import script from "./Pools.vue?vue&type=script&lang=ts&"
export * from "./Pools.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports